import { createAction } from '@reduxjs/toolkit';

import type { HostedFieldsTokenizePayload } from 'braintree-web';
import type { CustomerPaymentTypes } from './cart_payment_method.types';

const getPermissions = {
  pending: createAction('cartPaymentMethod/getPermissions/pending'),
  fulfilled: createAction<CustomerPaymentTypes>('cartPaymentMethod/getPermissions/fulfilled'),
  rejected: createAction('cartPaymentMethod/getPermissions/rejected'),
};

const save = {
  accept: createAction('checkout/savePaymentMethod/accept'),
  pending: createAction('checkout/savePaymentMethod/pending'),
  fulfilled: createAction<HostedFieldsTokenizePayload>('checkout/savePaymentMethod/fulfilled'),
  expire: createAction('checkout/savePaymentMethod/expire'),
  rejected: createAction<string | undefined>('checkout/savePaymentMethod/rejected'),
};

export default {
  getPermissions,
  save,
};
